import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ProjectPreviewWebGL from "../../common/components/ProjectPreview/ProjectPreview";

/**
 * Standalone preview page for opening ProjectPreviewWebGL in a new browser tab.
 * Reads configuration from URL parameters and passes to the ProjectPreview component.
 */
export default function PreviewPage() {
  const [searchParams] = useSearchParams();

  const projectId = Number(searchParams.get("projectId") || -1);
  const projectGroupId = Number(searchParams.get("projectGroupId") || -1);
  const name = searchParams.get("name") || "";

  // Update document title
  useEffect(() => {
    if (name) {
      document.title = `${name} - Preview`;
    }
  }, [name]);

  return (
    <div className="w-screen h-screen overflow-hidden">
      {/* Override ProjectPreview's h-3/4 and p-2 classes for fullscreen */}
      <style>
        {`
          #preview-page-root > div {
            height: 100% !important;
            padding: 0 !important;
          }
        `}
      </style>
      <div id="preview-page-root" className="w-full h-full">
        <ProjectPreviewWebGL projectId={projectId} projectGroupId={projectGroupId} />
      </div>
    </div>
  );
}
